import { Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { Store } from '@ngrx/store';
import { StepStatusUpdatePayloadService } from 'step-status-update-payload-service';
import { ToastrService } from 'ngx-toastr';
import { DialogService } from 'primeng/dynamicdialog';
import { ImagilityBaseResponse, PrimaryData, TaskStep } from 'app-models';
import { Subject } from 'rxjs';
import { APIEducationDetails, BaseEducationDetailsLibraryService } from 'base-education-details-library';
import { Router } from '@angular/router';
import { AppServicesLibraryService } from 'app-services-library';
import { DirtyFormGuard } from 'dirty-check-store';
import { first } from 'rxjs/operators';
import { ReferenceLibraryService } from 'reference-library';

@Component({
  selector: 'education-details-library',
  templateUrl: './education-details-library.component.html',
  styleUrls: ['./education-details-library.component.scss']
})
export class EducationDetailsLibraryComponent extends BaseEducationDetailsLibraryService implements OnInit, OnDestroy {

  @Input()
  primaryData;

  @Input()
  simplifyH1b;

  @Input() 
  isWizard: boolean = false;

  @Output()
  onDialogClose = new EventEmitter<any>();
  onSaveEmitSubject: Subject<void> = new Subject<void>();
  public inputData: PrimaryData;
  isSimplifyH1b: boolean;
  selectedState = 'simple';
  getSummaryMessaege$ = new Subject();

  formDirtyFromDifferentControls = false;
  showNext: boolean = false;
  showPrev: boolean = false; 
  isCustomTriggered : boolean = false;

  constructor(
    public store: Store<any>,
    public apiService: APIEducationDetails,
    public toastr: ToastrService,
    public stepStatusUpdatePayloadCostructionService: StepStatusUpdatePayloadService,
    public dialogService: DialogService,
    public router: Router,
    public appServicesLibraryService: AppServicesLibraryService,
    public guard: DirtyFormGuard,
    public referenceLibrary: ReferenceLibraryService

  ) {
    super(store, apiService, toastr, stepStatusUpdatePayloadCostructionService, dialogService, router, appServicesLibraryService, referenceLibrary);
  }

  ngOnInit() {
    this.isSimplifyH1b = this.simplifyH1b;
    this.inputData = this.primaryData;
    this.showNext = this.inputData?.showNext; 
    this.showPrev = this.inputData?.showPrev; 
    super.loadInit();
  }

  onChange($event) {
    this.selectedState = $event.value;
    if (this.selectedState === 'complete') {
      //this.redirectToProfile();
    }else if(this.selectedState === 'simple'){
      //this.isEditMode = false;
    }
  }

  handleClose() {
    this.guard.canDeactivate().pipe(first()).subscribe((response: boolean) => {
      if (response) {
        this.onDialogClose.emit();
      }else {
        return false;
      }
    });
  }

  ngOnDestroy() {
    super.onDestroy();
  }

  getApiStatus(event) {
    super.onGetApiStatus(event);
  }

  saveSummaryInfo() {
    this.onSaveEmitSubject.next();
    super.postFormSubmission();
    this.isCustomTriggered = true;
  }

}
